import { getSdk } from 'network/graphql-models';
import { GraphQLClient } from 'graphql-request';
import { API_URL } from 'appenv';
import { RequestDocument, Variables } from 'graphql-request/dist/types';

const noAuthGraphQLClient = new GraphQLClient(API_URL);
let authenticatedGraphQLClient: GraphQLClient | null = null;

export const setBearerTokenForCMSRequest = (accessToken: string) => {
  authenticatedGraphQLClient = accessToken == null ? null : new GraphQLClient(API_URL, {
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
};

/**
 * Get authenticated graphql client
 * Should not be called before setBearerTokenForCMSRequest
 *
 * @param throwWhenNoAuth default true, set false to allow return non-auth client
 */
// eslint-disable-next-line arrow-body-style
const getCMSRequestsGraphQLClient = (throwWhenNoAuth = true) => {
  // TODO: Before we migrate read permission control, it is not enforced to set token before get gql client
  // TODO: Uncomment the following line once we start to migrate it
  // if (authenticatedGraphQLClient == null && throwWhenNoAuth) throw Error('Not authenticated');
  return authenticatedGraphQLClient ?? noAuthGraphQLClient;
};

/**
 * Get authenticated & typed graphql sdk for CMS api
 *
 * @param throwWhenNoAuth default true, set false to allow request with non-auth client
 */
export const getCMSRequests = (throwWhenNoAuth = true) => getSdk(getCMSRequestsGraphQLClient(throwWhenNoAuth));

/**
 * Query the CMS GraphQL api with authenticated graphql-request
 *
 * @param document The gql document of the request
 * @param variables The variables of the request
 * @param throwWhenNoAuth default true, set false to allow request with non-auth client
 */
export const cmsRequest = <T = any, V = Variables>(
  document: RequestDocument, variables: V, throwWhenNoAuth = true,
): Promise<T> => getCMSRequestsGraphQLClient(throwWhenNoAuth).request(document, variables);

export default setBearerTokenForCMSRequest;
